import { render } from "./JobCallsView.vue?vue&type=template&id=bcff41ac&scoped=true&ts=true"
import script from "./JobCallsView.vue?vue&type=script&lang=ts"
export * from "./JobCallsView.vue?vue&type=script&lang=ts"

import "./JobCallsView.vue?vue&type=style&index=0&id=bcff41ac&scoped=true&lang=css"

import exportComponent from "D:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcff41ac"]])

export default __exports__